module.exports = __webpack_public_path__ + "img/9791186294116.0dbf718b.jpg";